"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersScreen = OrdersScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var search_input_1 = require("../../components/common/search-input");
var status_badge_1 = require("../../components/common/status-badge");
var orders_1 = require("../../features/apis/orders");
var organizations_1 = require("../../features/apis/organizations");
var use_permissions_1 = require("../../hooks/use-permissions");
var permissions_1 = require("../../interfaces/permissions");
function UploadIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" }) }));
}
function OrdersScreen() {
    var _a, _b, _c, _d;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var hasPermission = (0, use_permissions_1.usePermissions)().hasPermission;
    var _e = (0, react_2.useState)(1), page = _e[0], setPage = _e[1];
    var _f = (0, react_2.useState)(""), search = _f[0], setSearch = _f[1];
    var _g = (0, react_2.useState)(""), statusFilter = _g[0], setStatusFilter = _g[1];
    var _h = (0, react_2.useState)(""), orgFilter = _h[0], setOrgFilter = _h[1];
    var _j = (0, react_2.useState)(""), dateFrom = _j[0], setDateFrom = _j[1];
    var _k = (0, react_2.useState)(""), dateTo = _k[0], setDateTo = _k[1];
    var orgsData = (0, organizations_1.useGetOrganizationsQuery)({ page: 1, limit: 100 }).data;
    var organizations = ((_a = orgsData === null || orgsData === void 0 ? void 0 : orgsData.content) === null || _a === void 0 ? void 0 : _a.organizations) || [];
    var _l = (0, orders_1.useGetOrdersQuery)({
        page: page,
        limit: 10,
        search: search || undefined,
        status: statusFilter || undefined,
        organization_id: orgFilter || undefined,
        date_from: dateFrom || undefined,
        date_to: dateTo || undefined,
    }), data = _l.data, isLoading = _l.isLoading, isFetching = _l.isFetching;
    var orders = ((_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.orders) || [];
    var totalPages = ((_d = (_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.total_pages) || 1;
    // Helper to get organization name from populated field
    var getOrgName = function (item) {
        if (item.organization_id && typeof item.organization_id === "object") {
            return item.organization_id.name || "-";
        }
        return "-";
    };
    // Helper to get product info from populated field
    var getProductDenomination = function (item) {
        if (item.product_id && typeof item.product_id === "object") {
            return item.product_id.denomination || 0;
        }
        return 0;
    };
    var columns = [
        {
            key: "reference",
            label: "Reference",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-sm font-medium", children: item.reference_number }); },
        },
        {
            key: "original_filename",
            label: "File",
            render: function (item) { return ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-default-500", title: item.original_filename || undefined, children: item.original_filename || "-" })); },
        },
        {
            key: "organization",
            label: "Organization",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: getOrgName(item) }); },
        },
        {
            key: "total_recipients",
            label: "Recipients",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.total_recipients }); },
        },
        {
            key: "total_vouchers",
            label: "Vouchers",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.total_vouchers }); },
        },
        {
            key: "total_value",
            label: "Value",
            render: function (item) {
                var denomination = getProductDenomination(item);
                var totalValue = denomination * item.total_vouchers;
                return (0, jsx_runtime_1.jsxs)("span", { className: "font-medium", children: ["N$", (totalValue / 100).toFixed(2)] });
            },
        },
        {
            key: "status",
            label: "Status",
            render: function (item) { return (0, jsx_runtime_1.jsx)(status_badge_1.StatusBadge, { status: item.status }); },
        },
        {
            key: "uploaded_at",
            label: "Uploaded",
            render: function (item) { return ((0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: new Date(item.uploaded_at || item.created_at).toLocaleDateString("en-ZA", { timeZone: "Africa/Johannesburg" }) })); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", onPress: function () { return navigate("/orders/".concat(item._id)); }, children: "View" })); },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Orders", description: "Manage airtime orders", actions: __spreadArray(__spreadArray([], (hasPermission(permissions_1.MODULES.ORDERS, permissions_1.ACTIONS.AUTHORIZE)
                    ? [
                        {
                            label: "Pending Authorization",
                            variant: "bordered",
                            href: "/orders/pending",
                        },
                    ]
                    : []), true), [
                    {
                        label: "Upload Order",
                        icon: (0, jsx_runtime_1.jsx)(UploadIcon, {}),
                        href: "/orders/upload",
                    },
                ], false) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-4", children: [(0, jsx_runtime_1.jsx)(search_input_1.SearchInput, { placeholder: "Search by reference or filename...", value: search, onChange: function (v) {
                            setSearch(v);
                            setPage(1);
                        }, className: "w-64" }), (0, jsx_runtime_1.jsxs)("select", { value: statusFilter, onChange: function (e) {
                            setStatusFilter(e.target.value);
                            setPage(1);
                        }, className: "h-8 w-48 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Statuses" }), (0, jsx_runtime_1.jsx)("option", { value: "pending_authorization", children: "Pending Authorization" }), (0, jsx_runtime_1.jsx)("option", { value: "authorized", children: "Authorized" }), (0, jsx_runtime_1.jsx)("option", { value: "rejected", children: "Rejected" }), (0, jsx_runtime_1.jsx)("option", { value: "processing", children: "Processing" }), (0, jsx_runtime_1.jsx)("option", { value: "completed", children: "Completed" }), (0, jsx_runtime_1.jsx)("option", { value: "cancelled", children: "Cancelled" })] }), (0, jsx_runtime_1.jsxs)("select", { value: orgFilter, onChange: function (e) {
                            setOrgFilter(e.target.value);
                            setPage(1);
                        }, className: "h-8 w-48 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Organizations" }), organizations.map(function (org) { return ((0, jsx_runtime_1.jsx)("option", { value: org._id, children: org.name }, org._id)); })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("label", { className: "text-sm text-default-500", children: "From" }), (0, jsx_runtime_1.jsx)("input", { type: "date", value: dateFrom, onChange: function (e) {
                                    setDateFrom(e.target.value);
                                    setPage(1);
                                }, className: "h-8 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary" }), (0, jsx_runtime_1.jsx)("label", { className: "text-sm text-default-500", children: "To" }), (0, jsx_runtime_1.jsx)("input", { type: "date", value: dateTo, onChange: function (e) {
                                    setDateTo(e.target.value);
                                    setPage(1);
                                }, className: "h-8 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary" }), (dateFrom || dateTo || orgFilter || statusFilter) && ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", onPress: function () {
                                    setStatusFilter("");
                                    setOrgFilter("");
                                    setDateFrom("");
                                    setDateTo("");
                                    setPage(1);
                                }, children: "Clear" }))] })] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: orders, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, onRowClick: function (item) { return navigate("/orders/".concat(item._id)); }, emptyContent: "No orders found" })] }));
}
